<nav class="navbar navbar-expand-lg bg-primary navbar-transparent navbar-absolute" color-on-scroll="500">
    <div class="container">
        <div class="navbar-wrapper ml-auto mr-auto">
            <a class="navbar-brand d-none d-sm-none d-md-block" [routerLink]="['auth/login']">PINK LOUNGE</a>
            <a class="navbar-brand d-block d-sm-block d-md-none" [routerLink]="['auth/login']">PINK LOUNGE</a>
        </div>
    </div>
</nav>
<router-outlet></router-outlet>